// Supabase requires OAuth provider ids for custom OIDC providers to carry the
// `custom:` prefix in the `signInWithOAuth({ provider })` call. The backend's
// cohort/token-hook logic strips that prefix from both sides before comparing
// (see bonni-backend's normalizeProviderId in src/utils/linkedin-sso.ts), so
// an operator can set VITE_PUBLIC_LINKEDIN_SSO_PROVIDER_ID with or without the
// prefix and the backend won't notice either way. The frontend has no such
// tolerance: signInWithOAuth sends whatever string it's given straight to
// Supabase, so a value set WITHOUT the prefix silently 400s. Normalize here so
// either form works.
const CUSTOM_PROVIDER_PREFIX = "custom:";

export function normalizeLinkedInProviderId(value: string): string {
  const trimmed = value.trim();
  if (!trimmed) return trimmed;

  return trimmed.toLowerCase().startsWith(CUSTOM_PROVIDER_PREFIX)
    ? trimmed
    : `${CUSTOM_PROVIDER_PREFIX}${trimmed}`;
}
